import styled, { css } from 'styled-components';
import { tokens } from 'styles/tokens';

export const buttonStyle = css`
    border: none;
    font: inherit;
    color: inherit;
    background: none;
    cursor: pointer;

    text-align: center;
    border-radius: 5px;
    transition: background-color 0.2s ease-in-out, border-color 0.2s ease-in-out,
        color 0.2s ease-in-out;

    &:disabled {
        cursor: not-allowed;
        color: ${tokens.action.disabled};
    }
`;

export const Button = styled.button`
    ${buttonStyle}
`;
